import CustomText from 'components/common/text/CustomText';
import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';

interface ITab {
  index: number;
  label: string;
}

interface CreateProjectTabProps {
  tabTitle: string;
  tabIndex?: number;
  tabList?: ITab[];
  onTabChange?: (index: number) => void;
}

const CreateProjectTab = ({ tabTitle, tabIndex, tabList, onTabChange }: CreateProjectTabProps) => {
  return (
    <StyledCreateProjectTab $isTab={!!tabList}>
      <CustomText fontSize={20} fontColor="#222" fontWeight={600}>
        {tabTitle}
      </CustomText>
      {!!tabList && (
        <div className="createProjectTab__tab_box">
          {tabList?.map((tab: ITab) => {
            const isSelected = tabIndex === tab.index;

            return (
              <button
                className={cx('createProjectTab__tab_item', { selected: isSelected })}
                key={tab.index}
                onClick={() => !!onTabChange && onTabChange(tab.index)}
              >
                <CustomText
                  fontSize={18}
                  fontColor={isSelected ? '#00a6e2' : '#888'}
                  fontWeight={600}
                >
                  {tab.label}
                </CustomText>
              </button>
            );
          })}
        </div>
      )}
    </StyledCreateProjectTab>
  );
};

const StyledCreateProjectTab = styled.div<{ $isTab: boolean }>`
  padding: ${({ $isTab }) => ($isTab ? '20px 20px 0 20px' : '20px')};
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e1e1e7;
  .createProjectTab__tab_box {
    display: flex;
    .createProjectTab__tab_item {
      width: 100px;
      display: flex;
      justify-content: center;
      padding-bottom: 20px;
      &.selected {
        border-bottom: 3px solid #00a6e2;
      }
    }
  }
`;

export default CreateProjectTab;
